import React from "react";
import { VisitorTypeHost } from "@gettactic/api";
import { UserLabel } from "@cmp-src/labels/UserLabel/UserLabel";

export interface HostLabelProps {
  host: VisitorTypeHost;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
}

const mapHostToUser = (host: VisitorTypeHost) => ({
  id: host.id,
  name: host.name,
  email: host.email,
  profile_photo_url: host.profile_photo_url ?? null,
  title: host.title || ""
});

export const HostLabel: React.FC<HostLabelProps> = ({ host }) => {
  const user = mapHostToUser(host);

  return (
    <UserLabel
      user={user}
      variant="host"
      showTitle
      showEmail={false}
      allowTruncate
    />
  );
};
